export const analytics = {
  projectProgress: "Project Progress",
  hi: "Hi",
  realProgress: "Real Progress",
  welcomeBack: "Welcome Back",
  moduleStatistics: "Module Statistics",
  onTime: "On Time",
  overdue: "Overdue",
  constructionPercentage: "Construction progress",
  completed: "Completed",
  thisWeek: "This week",
  workForce: "Work force",
  hours: "Hours",
  completedTasks: "Completed tasks",
  analytics: "Analytics",
  addWidgets: "Add your widgets to display",
  projectStatistics: "Project statistics",
  rfis: "RFIs",
  tasks: "Tasks",
  submittals: "Submittals",
  delayed: "Delayed",
  closed: "Closed",
  pending: "Pending",
  onProgress: "On Progress",
  done: "Done",
  selectWidget: "Select the widget of your choice",
  widgetDisplayed: "The selected widget will be displayed on your Dashboard"
};
